import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import GraphQl from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import SmartTable from '../../shared/components/material-table';
import columns from './components/Columns';
import { listCycleClosingByEmployee } from '../../shared/queries/CycleClosing';
import { ACTION_NAME } from '../../shared/utils/constants';

const CycleClosing = (props) => {
  const [data, setData] = useState([]);
  const { t, history, dispatch } = props;

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadAllCycleClosings = () => {
    showLoading();
    const query = listCycleClosingByEmployee();
    GraphQl(query, {})
      .then((res) => {
        hideLoading();
        res.listCycleClosingByEmployee = res.listCycleClosingByEmployee.map(
          (item) => ({
            ...item,
            status: t(`general.open-closed.${item.cycleClosed}`),
          })
        );
        setData(res.listCycleClosingByEmployee);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/consolidacao-ciclo/mnt/${rowData.id}`, {
      data: rowData,
    });
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find(
        (a) => a.name === ACTION_NAME.VIEW_VISUALIZATION
      ).hidden = !propss.data.cycleClosed;
      copyProps.actions.find((a) => a.name === ACTION_NAME.EDIT).hidden =
        propss.data.cycleClosed;
    }
  };

  useEffect(() => {
    loadAllCycleClosings();
  }, []);

  return (
    <Fragment>
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <SmartTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    onRefreshClick={loadAllCycleClosings}
                    onEditClick={editItemClickHandler}
                    title={t('panels.cycle-consolidation')}
                    actionsDisabled
                    actionsDisabledByConditional={actionsDisabledByConditional}
                    onViewVisualizationClick={{
                      tooltip: t('general.tables.view-visualization'),
                      callback: editItemClickHandler,
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

CycleClosing.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CycleClosing)
);
